import { compose, withProps } from 'recompose';
import { ifElse, always, propEq } from 'ramda';
import withGiftCardLink from '../hoc/withGiftCardLink';
import hideWithoutGiftCardSales from '../hoc/hideWithoutGiftCardSales';

export const textDecider = ifElse(
  propEq('areGcSalesDisabledForBarber', true),
  always('Buy a Gift Card to use for future purchases'),
  always('Support us by prepaying for future services through a purchase of a Gift Card')
);

export default compose(
  hideWithoutGiftCardSales,
  withProps(props => ({
    text: textDecider(props),
  })),
  withGiftCardLink,
);



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardLink/GiftCardLinkContainer.js